module.exports = __webpack_public_path__ + "static/media/icon_Video_W.5e8c6d15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_Video_W.svg
// module id = 1936
// module chunks = 0